import React from 'react';

// Static empty / message block. No spinner, no animation by design.
const StateBlock = ({ icon = 'fa-inbox', title, text }) => (
  <div className="ad-state">
    <div className="ad-state-icon">
      <i className={`fas ${icon}`}></i>
    </div>
    {title && <p className="ad-state-title">{title}</p>}
    {text && <p className="ad-state-text">{text}</p>}
  </div>
);

export default StateBlock;
